import {Params} from '@feathersjs/feathers'

import {Permission, ProviderEmail, ProviderEmailId, ProviderId} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'providerEmail'

export type ProviderEmailRequest = Omit<ProviderEmail, 'id'> & {provider: ProviderId}

const get = async (permission: Permission | undefined, params?: Params) => {
  if (!!permission && [Permission.PROVIDER].includes(permission)) {
    return feathersService.find<ProviderEmail>(RESOURCE, params)
  }
  return []
}

export const getByProvider = async (permission: Permission | undefined, provider: ProviderId) => {
  const params = {
    query: {
      provider,
    },
  }
  return get(permission, params)
}

export const create = async (payload: ProviderEmailRequest) =>
  feathersService.create<ProviderEmail, ProviderEmailRequest>(RESOURCE, payload)

export const createMultiple = async (payload: ProviderEmailRequest[]) =>
  payload.length > 0
    ? feathersService.createMultiple<ProviderEmail, ProviderEmailRequest>(RESOURCE, payload)
    : Promise.resolve([])

export const update = async (payload: ProviderEmail, id: ProviderEmailId) =>
  feathersService.update<ProviderEmail>(RESOURCE, id, payload)

export const updateMultiple = async (
  payload: Record<ProviderEmailId, ProviderEmail>,
  ids: ProviderEmailId[]
) => Promise.all(ids.map(id => update(payload[id], id)))

export const remove = async (id: ProviderEmailId) =>
  feathersService.remove<ProviderEmail>(RESOURCE, id)

export const removeMultiple = async (ids: ProviderEmailId[]) =>
  Promise.all(ids.map(id => remove(id)))
